
import OrderPayment from "~/common/components/dialog/payDialog/PaymentNew.vue";
import store from '~/store/index'
import router from '~/router/router'
import i18n from '~/common/plugins/i18n.js';
const paymentDialog = {
  install(vue) {
    const FullNameInstance = vue.extend({
      template: `
        <OrderPayment class="direct-order-payment" :batchPay="batchPay" :orderId="id" @update="resultClose" :paymentVisible="visible" @hide="hide"></OrderPayment>
      `,
      components: { OrderPayment },
      props: ['paymentVisible', 'orderId', 'batchPay'],
      data() {
        return {
          id: null,
          visible: false,
        }
      },
      created() {
        this.id = this.orderId
        this.visible = this.paymentVisible
        this.wrapperVisible = this.visible
      },
      methods: {
        hide() {
          this.visible = false
        },
        resultClose() {
        },
      }
    });

    vue.prototype.$payment = (option) => {
      if(process.client) {
        const bodyChilds = document.body.children;
        const [payComponentFater, payComponent, payComponentResult] = Array.from(bodyChilds).reduce(
          (acc, item) => {
            if (item.classList.contains('direct-order-payment')) {
              acc[0].push(item);
            } else if (item.classList.contains('order-payment-dialog')) {
              acc[1].push(item);
            } else if (item.classList.contains('el-dialog__wrapper') && item.querySelector('.order-payment-result')) {
              acc[2].push(item);
            }
            return acc;
          },
          [[], [], []]
        );

        [...payComponent, ...payComponentFater, ...payComponentResult].forEach(item => document.body.removeChild(item));
      }

      let instance = new FullNameInstance({
        propsData: {
          ...option
        },
        store,
        router,
        i18n
      });

      let nameSpan = instance.$mount().$el;
      document.body.appendChild(nameSpan);
      instance.remove = function () {   //  该方法用于销毁实例
        document.body.removeChild(instance.$el);
        instance.$destroy()
      }
    }
  }
}


export default paymentDialog;
